import { set, toggle } from '@/utils/vuex'

export default {
  // setImage: set('image'),
  // setColor: set('color'),
  // toggleDrawer: toggle('drawer'),
  // setCrashCourseList: set('crashCourseList')
  setCrashCourseList (state, data) {
    state.crashCourseList = data
  },
}
